import LongPreview from '../../QuestionPreviews/LongPreview/LongPreview';

const LongQuestion = ({ question }) => {
  const { isActive } = question;

  return <>{!isActive && <LongPreview question={question} />}</>;
};

export default LongQuestion;
